import { KkmInfo, KkmRegStatusModel } from './kkm-info.types';

export const KKM_INFO: KkmInfo[] = [
  {
    title: 'kkm.settings.id',
    property: 'id',
  },
  {
    title: 'kkm.settings.model',
    property: 'model',
  },
  {
    title: 'kkm.settings.serial.factory.number',
    property: 'serialNumber',
  },
  {
    title: 'kkm.settings.year',
    property: 'year',
  },
  {
    title: 'kkm.registration.number',
    property: 'fnsKkmId',
  },
];

export const KKM_REG_STATUS: KkmRegStatusModel[] = [
  {
    regStatus: 0,
    title: 'kkm.status.UN_REG',
    link: null,
    className: 'error-text',
    showRegStatusChangedAt: false,
  },
  {
    regStatus: 2,
    title: 'kkm.status.UN_REG',
    link: null,
    className: 'error-text',
    showRegStatusChangedAt: false,
  },
  {
    regStatus: 3,
    title: 'kkm.status.FNS_REG_FAILED',
    link: '/main/kkms/register-kkm/',
    className: 'error-text clickable',
    showRegStatusChangedAt: true,
  },
  {
    regStatus: 4,
    title: 'kkm.status.REGISTRATION_SUCCESS',
    link: null,
    className: 'green-text',
    showRegStatusChangedAt: true,
  },
  {
    regStatus: 5,
    title: 'kkm.status.FNS_REREG_FAILED',
    link: '/main/kkms/re-register-kkm/',
    className: 'error-text clickable',
    showRegStatusChangedAt: true,
  },
  {
    regStatus: 6,
    title: 'kkm.status.UNREG_SENT_TO_FNS',
    link: null,
    className: 'grey-text',
    showRegStatusChangedAt: true,
  },
  {
    regStatus: 7,
    title: 'kkm.status.FNS_UNREG_FAILED',
    link: '/main/kkms/deregister-kkm/',
    className: 'error-text clickable',
    showRegStatusChangedAt: true,
  },
  {
    regStatus: 8,
    title: 'kkm.status.UNREGISTERED',
    link: null,
    className: 'error-text',
    showRegStatusChangedAt: true,
  },
  {
    regStatus: 9,
    title: 'kkm.status.UNREGISTERED',
    link: null,
    className: 'grey-text',
    showRegStatusChangedAt: true,
  },
  {
    regStatus: 10,
    title: 'kkm.status.REREG_SENT_TO_FNS',
    link: null,
    className: 'grey-text',
    showRegStatusChangedAt: true,
  },
  {
    regStatus: 11,
    title: 'kkm.status.REGISTRATION_SUCCESS',
    link: null,
    className: 'green-text',
    showRegStatusChangedAt: false,
  },
  {
    regStatus: 13,
    title: 'kkm.status.UN_REG',
    link: null,
    className: 'error-text',
    showRegStatusChangedAt: false,
  },
  {
    regStatus: 14,
    title: 'kkm.status.DISCONNECTED_OFD',
    link: null,
    className: 'grey-text',
    showRegStatusChangedAt: true,
  },
  {
    regStatus: 15,
    title: 'kkm.status.REGISTRATION_SUCCESS',
    link: null,
    className: 'green-text',
    showRegStatusChangedAt: false,
  },
  {
    regStatus: 16,
    title: 'kkm.status.FNS_REREG_FAILED',
    link: '/main/kkms/cancel-disconnection-ofd-agreement/',
    className: 'error-text clickable',
    showRegStatusChangedAt: false,
  },
  {
    regStatus: 17,
    title: 'kkm.status.FNS_REG_FAILED',
    link: '/main/kkms/register-kkm/',
    className: 'error-text clickable',
    showRegStatusChangedAt: false,
  },
];
